import { render, staticRenderFns } from "./PrintTarifasReport.vue?vue&type=template&id=4f38441c&"
import script from "./PrintTarifasReport.vue?vue&type=script&lang=js&"
export * from "./PrintTarifasReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports